import React, { useEffect, useRef, useState, useMemo } from "react";
import Select, { components } from "react-select";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
} from "react-google-places-autocomplete";
import Resizer from "react-image-file-resizer";
import axios from "axios";
import moment from "moment";
import { serverUrl } from "../../components/Helpers/Config";
import {
  useHistory,
  useLocation,
  useParams,
  useRouteMatch,
} from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useDispatch, useSelector } from "react-redux";
import { getPosts } from "../../redux/actions/journal";
import { addShowcasePost } from "../../redux/actions/showcase";
import { AiOutlineLeft, AiOutlineCloseCircle } from "react-icons/ai";
import { BiLeftArrowAlt } from "react-icons/bi";
import { BsArrowLeft } from "react-icons/bs";
import { FaArrowLeftLong } from "react-icons/fa6";
import ModalShare from "../Journal/ModalShare";
import { IoMdCloseCircle } from "react-icons/io";
import ButtonBlue from "../../components/Button/ButtonBlue";
import DPEditor from "../../components/Editor/DPEditor";
import "../../styles/addpost.styles.scss";
import Swal from "sweetalert2";
import { staticFiles } from "../../components/Helpers/Static";
import ButtonSave from "../../components/Button/ButtonSave";
import { tokenAuthorize } from "../../components/Helpers/Common";
import ModalFeaturedImage from "../../components/Modal/ModalFeaturedImage";
import ButtonCommon from "../../components/Button/ButtonCommon";
import ActionButton from "../../components/Button/ActionButton";
import CancelButton from "../../components/Button/CancelButton";
import RatingStar from "../../components/LikeComment/RatingStar";
import ButtonGreen from "../../components/Button/ButtonGreen";
import SelectModalDropDown from "../../components/Button/SelectModalDropDown";
import {
  ActiveIconColor,
  ButtonCommonTop,
  ListButton,
  Card,
  ButtonCommonTopGrey,
  DivBadge,
  ButtonCommonGreen,
} from "../Theme";
import SubNavbar from "../../components/Navbar/SubNavbar";
import { Tabs, Tab, Box, Typography, fabClasses } from "@mui/material";
import ReviewIcon from "../../common/images-new/review-icon.svg";
import MetaTagIcon from "../../common/images-new/meta-tag-icon.svg";
import ReviewTabIcon from "../../common/images-new/review-tab-icon.svg";
import ModalReflectionReview from "../../components/Modal/ModalReflectionReview";
import ModalQuickPoll from "../../components/Modal/ModalQuickPoll";
import { getUserNavigationConfrimPopup } from "../../redux/actions/commonAction";
import {
  getReflectionFeedbackModels,
  getReflectionFeedbackHistory,
  getReflectionFeedbackProcessing,
} from "../../redux/actions/reflectionFeedback";
import QuickPoll from "./QuickPoll";
import MarkDownContent from "./MarkDownContent";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { PanelGroup, Panel, PanelResizeHandle } from "react-resizable-panels";
import CROSS_BLACK_ICON from "@mui/icons-material/Clear";
import { Progress } from "react-sweet-progress";
import "react-sweet-progress/lib/style.css";
import { ButtonCommonTopNew } from "../Theme";
import { use } from "react";
import NavTabs from "../../components/Navbar/NavTabs";
import CollectionsIcon from "@mui/icons-material/Collections";
import { FcGallery } from "react-icons/fc";
import { BsStars } from "react-icons/bs";
import { GET_THEME_LOADER } from "../../redux/actions/auth";
//accept =application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordProcessing...ml.document, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, ,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.slideshow,application/vnd.openxmlformats-officedocument.presentationml.presentation
import { Tooltip } from '@mui/material';
const TabPanel = ({ children, value, index }) => {
  return (
    <div hidden={value !== index} className={value === index ? "flex-1 flex flex-col min-h-0" : ""}>
      {value === index && (
        <Box sx={{ p: 2, display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
          <div className="flex-1 flex flex-col min-h-0">{children}</div>
        </Box>
      )}
    </div>
  );
};

const MultiValueCustom = (props) => {
  const { data } = props;
  return (
    <components.MultiValue {...props}>
      <div
        className="flex items-center gap-1 px-2 py-0.5 rounded-lg text-sm"
        style={{
          backgroundColor: "#ccc",
          color: "black",
          maxWidth: '200px',
          overflow: 'hidden',
        }}
      >
        {/* {props.data.label} */}
        <Tooltip title={props.data.label}>
          <span
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              flex: 1, // 👈 take available space
            }}
          >
            {props.data.label}
          </span>
        </Tooltip>
        <span
          className="ml-1 cursor-pointer hover:text-gray-700"
          onClick={(e) => {
            e.stopPropagation();
            props.removeProps.onClick();
          }}
          style={{
            marginLeft: 6,
            cursor: 'pointer',
            flexShrink: 0, // 👈 prevents hiding
            fontWeight: 'bold',
          }}
        >
          ✕
        </span>
      </div>
    </components.MultiValue>
  );
  // const MultiValueCustom = (props) => {
  //     return (
  //         <components.MultiValue {...props}>
  //             <div
  //                 className="flex items-center gap-1 px-2 py-0.5 rounded-lg text-sm"
  //                 style={{
  //                     backgroundColor: "var(--varBlueColor)",
  //                     color: "white"
  //                 }}
  //             >
  //                 {props.data.label}
  //                 <span
  //                     className="ml-1 cursor-pointer hover:text-gray-200"
  //                     onClick={(e) => {
  //                         e.stopPropagation();
  //                         props.removeProps.onClick();
  //                     }}
  //                 >
  //                     ✕
  //                 </span>
  //             </div>
  //         </components.MultiValue>
  //     );
};
const PostEditor = (props) => {
  const location = useLocation();
  const uploaderRef = useRef();
  const [contentEditor, setContentEditor] = useState();
  const [dublicateContentEditor, setDublicateContentEditor] = useState();
  const [isOpenModal, setisOpenModal] = useState(false);
  const [isOpenModalReflectionReview, setisOpenModalReflectionReview] =
    useState(false);
  const [isOpenQuickPoll, setisOpenQuickPoll] = useState(false);
  const handleEditorChange = (content, editor) => {
    setContentEditor(content);
    if (dublicateContentEditor != contentEditor) {
      dispatch(getUserNavigationConfrimPopup(true));
    } else {
      dispatch(getUserNavigationConfrimPopup(false));
    }
  };
  const history = useHistory();
  const urlParams = useParams();
  const featImageRef = useRef();
  const [isLoading, setLoading] = useState(false);
  // const [featureImage, setfeatureImage] = useState(false);
  const [modelVal, setModel] = useState("");
  const { path } = useRouteMatch();
  const isEditMode =
    useRouteMatch({
      path: `/journal/edit/:postId`,
      strict: false,
      sensitive: false,
    }) !== null;
  const [isAutoSavedEditMode, setAutoSavedEditMode] = useState(false);
  const dispatch = useDispatch();
  const [post, setPost] = useState({
    title: "",
    cover: "",
    tags: [],
    courses: [],
    events: [],
    values: [],
    location: { label: "", value: "" },
    attachments: [],
  });
  const [featImgFile, setFeatImgFile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [files, setFiles] = useState([]);
  const [extension, setextension] = useState(null);
  const [quickPoll, setQuickPoll] = useState([]);
  const reflectionFeedbackModel = useSelector(
    (state) => state.reflectionFeedbackReducer.reflectionFeedback || []
  );
  const reflectionFeedbackHistoryTab = useSelector(
    (state) =>
      state.reflectionFeedbackReducer.reflectionFeedbackHisotry || false
  );
  const [value, setValue] = useState(reflectionFeedbackHistoryTab ? 1 : 0);
  const [htmlEvaluation, setHtmlEvaluation] = useState("");
  const [feedbackButtonText, setfeedbackButtonText] = useState("Get Feedback");
  const [modelError, setModelError] = useState(
    "Please choose any of the model to review!"
  );
  const [feedbackHistory, setFeedbackHistory] = useState([]);
  const [defaultModelVal, setDefaultModelVal] = useState("");
  const tabsRef = useRef(null);
  const leftContainerRef = useRef(null);
  const [leftHeight, setLeftHeight] = useState(0);

  useEffect(() => {
    if (!leftContainerRef.current) return;
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setLeftHeight(entry.contentRect.height);
      }
    });
    observer.observe(leftContainerRef.current);
    return () => observer.disconnect();
  }, []);
  const [ButtonWrap, setButtonWrap] = useState(false);
  const historyEnabled = useSelector((state) => state.journal.historyEnabled);
  const [isAutoSaveVisible, setAutoSaveVisible] = useState(false);
  const [autoSaveDuration, setAutoSaveDuration] = useState(null);
  const [autoSavedText, setAutoSaveText] = useState("");
  const [saveButtonDisable, setSaveButtonDisable] = useState(false);
  const userNavigatingConfrimPopup = useSelector(
    (state) => state.commonData.userNavigatingConfrimPopup || false
  );
  //Attachments Limitations
  const [attachmentExtension, setAttachmentExtension] = useState(null);
  const [attachmentFileSize, setAttachmentFileSize] = useState(null);
  const [errorFileSizeLimits, setErrorFileSizeLimits] = useState([]);
  const [errorFileNotExtention, setErrorFileNotExtention] = useState([]);
  const modalRef = useRef();
  const [show, setShow] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const sourceRef = useRef(null);
  const [shouldCheckFiles, setShouldCheckFiles] = useState(false);

  const goBack = (postId = 0, str) => {
    setTimeout(() => {
      localStorage.setItem("journalSave", "true");
    }, 0);
    const prevPage =
      location.state && location.state.src ? location.state.src : "/journal";
    const tabId =
      location.state && location.state.tabId ? location.state.tabId : -1;
    const taskId =
      location.state && location.state.taskId ? location.state.taskId : -1;
    if (str == "respond") {
      if (tabId > 0 && postId > 0) {
        dispatch(
          addShowcasePost(tabId, postId, props.location?.state?.showcasesCount)
        );
      }
      if (taskId > 0 && postId > 0) {
        let attachmentIds = [];
        attachmentIds.push(postId);

        axios
          .post(serverUrl.LearningResponse + `/${taskId}`, {
            attachments: attachmentIds,
          })
          .then((resp) => {
            if (resp.status === 200) {
              if (props.location?.state?.data == "journal") {
                Swal.fire({
                  title: "Success",
                  text: "Your post has been submitted",
                  icon: "success",
                }).then((result) => {
                  if (result.isConfirmed) {
                    history.push(prevPage, { tabId });
                    history.goBack();
                  }
                });
              }
            }
          })
          .catch((err) => {
            tokenAuthorize(err?.response?.status);
          });
      } else {
        history.push("/journal");
      }
    }
    if (str == "journal") {
      if (props.location?.state?.data == "journal") {
        Swal.fire({
          title: "Success",
          text: "Your post has been saved to journal",
          icon: "success",
        }).then((result) => {
          if (result.isConfirmed) {
            history.push(prevPage, { tabId });
            history.goBack();
          }
        });
      }
    }
    if (str === "autoReflectionSave") {
      history.push("/journal");
    }
  };

  const [deviceWidth, setDeviceWidth] = useState(window.innerWidth);
  const handleWindowResize = () => {
    setDeviceWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
  });

  //Auto save timeout
  useEffect(() => {
    if (
      autoSaveDuration &&
      post.title &&
      feedbackButtonText === "Get Feedback" &&
      uploadProgress === 0
    ) {
      const intervalId = setInterval(() => {
        addEdit("autoSave");
        setTimeout(() => {
          setAutoSaveVisible((isAutoSaveVisible) => !isAutoSaveVisible);
        }, 5000);
      }, autoSaveDuration * 1000);
      return () => clearInterval(intervalId);
    }
  }, [
    autoSaveDuration,
    post,
    feedbackButtonText,
    contentEditor,
    isAutoSaveVisible,
    isAutoSavedEditMode,
    uploadProgress,
  ]);

  const resizeLocalStorage = useMemo(
    () => ({
      getItem(name) {
        try {
          return JSON.parse(localStorage.getItem(name)) || "";
        } catch (error) {
          console.error(error);
          return "";
        }
      },
      setItem(name, value) {
        localStorage.setItem(name, JSON.stringify(value));
      },
    }),
    []
  );

  useEffect(() => {
    if (reflectionFeedbackModel?.reflection?.length != 0) {
      setDefaultModelVal(
        reflectionFeedbackModel?.reflection?.find(
          (model) => model.is_default_model == true
        )?.id || ""
      );
      setModel(
        reflectionFeedbackModel?.reflection?.find(
          (model) => model.is_default_model == true
        )?.id || ""
      );
    }
  }, [reflectionFeedbackModel]);

  useEffect(() => {
    dispatch(getReflectionFeedbackModels());
    dispatch(getUserNavigationConfrimPopup(false));
    // const postData = location.state ? location.state.post : null;
    if (isEditMode && urlParams.postId != null) {
      // setLoading(true);

      // Reflections contents
      axios
        .get(serverUrl.ReflectionPost + "/" + urlParams.postId)
        .then((resp) => {
          if (resp.status === 200) {
            let postData = resp.data.post;
            try {
              let courses = postData.courses.map((el) => ({
                value: el.id,
                label: el.value,
              }));
              let events = postData.events.map((el) => ({
                value: el.id,
                label: el.value,
              }));
              let values = postData.values.map((el) => ({
                value: el.id,
                label: el.value,
              }));
              let groups = postData.groups.map((el) => ({
                value: el.id,
                label: el.value,
              }));
              setPost({
                ...post,
                id: postData.reflection_id,
                title: postData.reflection_title,
                cover: postData.reflection_image,
                tags: postData.hashtag,
                location: {
                  label: postData.reflection_address,
                  value: "",
                },
                lat: postData.reflection_latitude,
                lng: postData.reflection_longitude,
                attachments: postData.docs ? postData.docs : [],
                courses,
                events,
                values,
                groups,
              });
              setContentEditor(postData.reflection_content);
              setDublicateContentEditor(postData.reflection_content);
              // setLoading(false);
              //Reflections Models
              axios
                .get(
                  serverUrl.ReflectionFeedBackHistory + "/" + urlParams.postId
                )
                .then((resp) => {
                  if (resp.status === 200) {
                    setFeedbackHistory(resp.data.results);
                    let defaultModelVal =
                      reflectionFeedbackModel?.reflection?.filter(
                        (x) =>
                          x.id ===
                          resp.data.results[resp.data.results.length - 1]
                            .model_id
                      )[0]?.id || "";
                    setModel(defaultModelVal);
                    setDefaultModelVal(defaultModelVal);
                    // setReview(true);
                    // setHtmlEvaluation(resp.data.results == 1 ? resp.data.results.feedback_text : resp.data.results[resp.data.results.length - 1].feedback_text);
                    if (
                      reflectionFeedbackHistoryTab &&
                      resp.data.results &&
                      resp.data.results.length > 0
                    ) {
                      setReview(true);
                      setHtmlEvaluation(
                        resp.data.results[resp.data.results.length - 1]
                          .feedback_text
                      );
                      dispatch(getReflectionFeedbackHistory(false));
                    }
                  }
                })
                .catch((err) => {
                  tokenAuthorize(err?.response?.status);
                  goBack("", "");
                });
            } catch (err) {
              console.log(err);
              // setLoading(false);
            }
          }
        })
        .catch((err) => {
          tokenAuthorize(err?.response?.status);
          goBack("", "");
        });
    } else {
    }
    //Reflection Auto Save
    axios
      .get(serverUrl.ReflectionAutoSave)
      .then((resp) => {
        if (resp.status === 200) {
          setAutoSaveDuration(resp.data ? resp.data : null);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
      });
    //Attachment Limitations
    axios
      .get(serverUrl.AttachmentsLimit)
      .then((resp) => {
        if (resp.status === 200) {
          setAttachmentExtension(
            resp?.data?.results?.attachment_types.length != 0
              ? resp?.data?.results?.attachment_types.join(",")
              : null
          );
          setAttachmentFileSize(
            resp?.data?.results?.attachment_size
              ? resp?.data?.results?.attachment_size
              : null
          );
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
      });
  }, []);
  // useEffect(() => {
  //     if (featImgFile) {
  //         const objectURL = URL.createObjectURL(featImgFile);
  //         setPost(prevState => ({
  //             ...prevState,
  //             cover: objectURL
  //         }));
  //         return () => URL.revokeObjectURL(objectURL);
  //     }
  // }, [featImgFile]);
  const [valOptions, setValOptions] = useState([]);
  const [couOptions, setCouOptions] = useState([]);
  const [evOptions, setEvOptions] = useState([]);

  // useEffect(() => {
  //     setLoading(true);
  //     const getData = async () => {
  //         const responseCourses = await axios.get(serverUrl.courses2)
  //             .then(res =>
  //                 res.data?.results?.length > 0 && res.data.results.forEach(item => {
  //                     setCouOptions(prev => [...prev, { label: item.course_title, value: item.course_id }])
  //                 })).catch(err => {
  //                     tokenAuthorize(err?.response?.status);
  //                     goBack("", "")
  //                     setLoading(false);
  //                 })
  //         const responseValues = await axios.get(serverUrl.values2)
  //             .then(res =>
  //                 res.data?.results?.length > 0 && res.data.results.forEach(item => {
  //                     setValOptions(prev => [...prev, { label: item.value_title, value: item.value_id }])
  //                 })).catch(err => {
  //                     tokenAuthorize(err?.response?.status);
  //                     goBack("", "")
  //                     setLoading(false);
  //                 })
  //         const responseEvents = await axios.get(serverUrl.events2)
  //             .then((res) =>
  //                 res.data?.results?.length > 0 ?
  //                     (res.data.results.forEach(item => {
  //                         setEvOptions(prev => [...prev, { label: item.event_title, value: item.event_id }])
  //                     }), setLoading(false)) : setLoading(false)).catch(err => {
  //                         tokenAuthorize(err?.response?.status);
  //                         goBack("", "")
  //                         setLoading(false);
  //                     })
  //     }
  //     getData();
  // }, [])

  useEffect(() => {
    const getData = async () => {
      dispatch({ type: GET_THEME_LOADER, payload: true });
      const coursesPromise = axios
        .get(serverUrl.courses2)
        .then((res) => {
          if (res.data?.results?.length > 0) {
            const grouped = {};
            res.data.results.forEach((item) => {
              if (!grouped[item.course_category_name]) {
                grouped[item.course_category_name] = [];
              }
              grouped[item.course_category_name].push({
                value: item.course_id,
                label: item.course_title,
                sortOrder: item.course_sort_order,
              });
            });

            const formatted = Object.keys(grouped)
              .sort((a, b) => a.localeCompare(b))
              .map((category) => ({
                label: category,
                options: grouped[category]
                  .sort((a, b) => a.sortOrder - b.sortOrder) // order by course_sort_order
                  .map(({ value, label }) => ({
                    value,
                    label,
                    filterValue: label + " " + category,
                  })),
              }));

            setCouOptions(formatted);
          }
        })
        .catch((err) => {
          tokenAuthorize(err?.response?.status);
          goBack("", "");
        });

      const valuesPromise = axios
        .get(serverUrl.values2)
        .then((res) => {
          if (res.data?.results?.length > 0) {
            // const grouped = {};
            // res.data.results.forEach((item) => {
            //   if (!grouped[item.category_title]) {
            //     grouped[item.category_title] = [];
            //   }
            //   grouped[item.category_title].push({
            //     value: item.value_id,
            //     label: item.value_title,
            //   });
            // });

            // const formatted = Object.keys(grouped)
            //   .sort((a, b) => a.localeCompare(b))
            //   .map((category) => ({
            //     label: category,
            //     options: grouped[category].sort((a, b) =>
            //       a.label.localeCompare(b.label)
            //     ),
            //   }));

            // setValOptions(formatted);
            const grouped = {};

            // step 1: group by visualization → category → options
            res.data.results.forEach((item) => {
              if (!grouped[item.category_visualization]) {
                grouped[item.category_visualization] = [];
              }

              let category = grouped[item.category_visualization].find(
                (c) => c.key === item.category_title
              );

              if (!category) {
                category = {
                  key: item.category_title,
                  label: `${item.category_visualization} - ${item.category_title}`,
                  sortOrder: item.category_sort_order,
                  options: [],
                };
                grouped[item.category_visualization].push(category);
              }

              category.options.push({
                value: item.value_id,
                label: item.value_title,
                sortOrder: item.value_sort_order,
              });
            });

            // step 2: sort categories and options
            Object.keys(grouped).forEach((vizKey) => {
              grouped[vizKey] = grouped[vizKey]
                .sort((a, b) => a.sortOrder - b.sortOrder)
                .map((cat) => ({
                  ...cat,
                  options: cat.options.sort(
                    (a, b) => a.sortOrder - b.sortOrder
                  ),
                }));
            });

            // step 3: format for usage
            const formatted = Object.entries(grouped)
              .sort(([a], [b]) => a.localeCompare(b)) // sort visualization groups
              .flatMap(([visualization, categories]) =>
                categories.map((cat) => ({
                  label: `${visualization}: ${cat.key}`, // group label
                  options: cat.options.map((opt) => ({
                    value: opt.value,
                    label: opt.label,
                    filterValue: `${visualization}: ${cat.key} ` + opt.label,
                  })),
                }))
              )
              .sort((a, b) => a.label.localeCompare(b.label));
            setValOptions(formatted);
          }
        })
        .catch((err) => {
          tokenAuthorize(err?.response?.status);
          goBack("", "");
        });

      const eventsPromise = axios
        .get(serverUrl.events2)
        .then((res) => {
          if (res.data?.results?.length > 0) {
            const sorted = res.data.results.sort((a, b) =>
              a.event_title.localeCompare(b.event_title)
            );

            const formatted = sorted.map((item) => ({
              label: item.event_title,
              value: item.event_id,
            }));

            setEvOptions(formatted);
          }
        })
        .catch((err) => {
          tokenAuthorize(err?.response?.status);
          goBack("", "");
        });

      // Run all in parallel and always turn off loader
      await Promise.allSettled([coursesPromise, valuesPromise, eventsPromise]);

      // setLoading(false); // end loader
      dispatch({ type: GET_THEME_LOADER, payload: false });
      // localStorage.setItem("themeLoader", false);
    };

    getData();
  }, []);

  // useEffect(() => {
  //   const data = valOptions?.filter(
  //     (val) => val.value == props?.location?.state?.valueId
  //   );
  //   if (data?.length > 0) {
  //     setPost({
  //       ...post,
  //       values: data,
  //     });
  //   }
  // }, [props?.location?.state?.valueId, valOptions]);
  useEffect(() => {
    if (props?.location?.state?.valueId && valOptions?.length > 0) {
      const data = valOptions
        .flatMap((group) => group.options) // flatten all options from groups
        .filter((val) => val.value == props.location.state.valueId);

      if (data.length > 0) {
        setPost((prev) => ({
          ...prev,
          values: data,
        }));
      }
    }
  }, [props?.location?.state?.valueId, valOptions]);

  const addTags = (e) => {
    let str = e.target.value.replace(/\s+/g, "");
    if (str !== "") {
      setPost({
        ...post,
        tags: [...post.tags, str],
      });
      e.target.value = "";
    }
    dispatch(getUserNavigationConfrimPopup(true));
  };
  const removeTags = (id) => {
    setPost({
      ...post,
      tags: [...post.tags.filter((_, index) => index !== id)],
    });
    dispatch(getUserNavigationConfrimPopup(true));
  };
  const addFiles = (e) => {
    let fileList = [],
      fileNames = [],
      errorFiles = [];
    setErrorFileSizeLimits([]);
    setErrorFileNotExtention([]);
    const allowedExtensions = (attachmentExtension || "")
      .split(",")
      .map((ext) => ext.trim().toLowerCase())
      .filter(Boolean); // removes empty values

    const maxSizeMB = attachmentFileSize ?? Infinity;
    Array.from(e.currentTarget.files).forEach((file) => {
      //file size convert to check MB format
      const sizeInMB = file.size / (1024 * 1024);
      const fileExt = "." + file.name.split(".").pop().toLowerCase();

      const isSizeValid = sizeInMB <= maxSizeMB;
      const isExtValid =
        allowedExtensions.length === 0 || allowedExtensions.includes(fileExt);

      if (isSizeValid && isExtValid) {
        fileList.push(file);
        fileNames.push(file.name);
      } else {
        if (!isSizeValid) {
          setErrorFileSizeLimits((prev) => [...prev, file]);
        } else {
          setErrorFileNotExtention((prev) => [...prev, file]);
        }
        errorFiles.push(file);
      }
    });

    setFiles([...files, ...fileList]);
    setPost({
      ...post,
      attachments: [...post.attachments, ...fileNames],
    });
    dispatch(getUserNavigationConfrimPopup(true));
    if (errorFiles.length > 0) {
      setShow(true);
    }
  };
  const removeFile = (id, name) => {
    setPost({
      ...post,
      attachments: [...post.attachments.filter((_, index) => index !== id)],
    });
    setFiles((prev) => prev.filter((file) => file.name !== name));
    dispatch(getUserNavigationConfrimPopup(true));
  };
  const submitPost = async (featUrl = "", attachments = [], str, url) => {
    const prevPage =
      location.state && location.state.src
        ? location.state.src
        : "/journal";
    const tabId =
      location.state && location.state.tabId ? location.state.tabId : -1;
    const taskId =
      location.state && location.state.taskId
        ? location.state.taskId
        : -1;
    let lat = "",
      lng = "";
    let data = null;
    try {
      if (
        post.location &&
        post.location.label &&
        post.location.label.length > 0
      ) {
        await geocodeByAddress(post.location.label)
          .then((results) => {
            if (results.length > 0) {
              lat = results[0].geometry.location.lat();
              lng = results[0].geometry.location.lng();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } catch (error) {
      console.log(error);
    }
    data = {
      reflection_title: post.title,
      reflection_content: contentEditor,
      reflection_image: featUrl.length > 0 ? featUrl : post.cover,
      reflection_values: post.values
        ? post.values.map((item) => item.value)
        : [],
      reflection_address: post.location.label,
      reflection_course: post.courses
        ? post.courses.map((item) => item.value)
        : [],
      reflection_events: post.events
        ? post.events.map((item) => item.value)
        : [],
      reflection_hashtag: post.tags,
      reflection_latitude: lat,
      reflection_longitude: lng,
      reflection_media: post.attachments,
      new_attachments: attachments,
      reflection_shared_type: 1,
    };
    if (data === null) {
      Swal.fire({
        heightAuto: false,
        title: "Error",
        text: "Cannot save the post",
      }).then((result) => { });
      return;
    }
    if (
      (urlParams.postId == null || urlParams.postId == undefined) &&
      !isAutoSavedEditMode
    ) {
      axios
        .post(serverUrl.Post, data)
        .then(async (res) => {
          setShouldCheckFiles(true);
          setSaveButtonDisable(false);
          // should be loading new data, then give notifications, meanwhile:
          if (location?.state?.journal == true) {
            //For QuickPoll UI development so code commented
            // Swal.fire({
            //     title: 'Success',
            //     text: "Post has been created",
            //     icon: "success"
            // })
          }
          //goBack(res.data.postId, str);
          //PROD Issue
          if (tabId > 0 && res?.data?.postId > 0) {
            dispatch(
              addShowcasePost(
                tabId,
                res?.data?.postId,
                props.location?.state?.showcasesCount
              )
            );
          }
          if (taskId > 0 && res?.data?.postId > 0) {
            let attachmentIds = [];
            attachmentIds.push(res?.data?.postId);

            // axios
            //   .post(serverUrl.LearningResponse + `/${taskId}`, {
            //     attachments: attachmentIds,
            //   })
            //   .then((resp) => {
            //     if (resp.status === 200) {
            //       if (props.location?.state?.data == "journal") {
            //         // Swal.fire({
            //         //     title: 'Success',
            //         //     text: 'Your post has been submitted',
            //         //     icon: 'success'
            //         // }).then((result) => {
            //         //     if (result.isConfirmed) {
            //         //         history.push(prevPage, { tabId });
            //         //         history.goBack()
            //         //     }
            //         // })
            //       }
            //     }
            //   })
            //   .catch((err) => {
            //     tokenAuthorize(err?.response?.status);
            //   });

            try {
              const resp = await axios.post(
                serverUrl.LearningResponse + `/${taskId}`,
                {
                  attachments: attachmentIds,
                }
              );

              if (resp.status === 200) {
                if (props.location?.state?.data === "journal") {
                  // Swal.fire({
                  //   title: 'Success',
                  //   text: 'Your post has been submitted',
                  //   icon: 'success'
                  // }).then((result) => {
                  //   if (result.isConfirmed) {
                  //     history.push(prevPage, { tabId });
                  //     history.goBack();
                  //   }
                  // });
                }
              }
            } catch (err) {
              tokenAuthorize(err?.response?.status);
            }
          }
          if (str === "autoReflectionSave" || str === "autoSave") {
            history.push(`/journal/edit/${res?.data?.postId}`, location.state);
            setAutoSavedEditMode(true);
            if (str !== "autoSave") {
              handleGetFeedBackButton(res?.data?.postId);
            } else {
              setAutoSaveText(
                "Auto-saved at " +
                moment().format("DD/MM/YYYY, hh:mm:ss A") +
                (files?.length > 0
                  ? ". Auto save doesn't includes attachment."
                  : ".")
              );
            }
          } else {
            if (str == 'respond') {
              history.push(prevPage, { taskId });
              // history.goBack()
            } else {
              history.push("/journal");
            }

            //setisOpenQuickPoll(isOpenQuickPoll ? !isOpenQuickPoll : true);
            Swal.fire({
              title: "Success",
              text: "Post has been created",
              icon: "success",
            });
          }

          dispatch(getPosts());
        })
        .catch((err) => {
          tokenAuthorize(err?.response?.status);
          console.log(err);
        });
    } else {
      axios
        .put(`${serverUrl.Post}/${urlParams.postId}`, data)
        .then(async (res) => {
          setShouldCheckFiles(true);
          setSaveButtonDisable(false);
          // should be loading new data, then give notifications, meanwhile:
          if (
            location?.state?.showCase == true ||
            location?.state?.journal == true
          ) {
            //For QuickPoll UI development so code commented
            // Swal.fire({
            //     title: 'Success',
            //     text: "Post has been updated",
            //     icon: "success"
            // })
          }
          dispatch(getPosts());
          if (str == "autoReflectionSave") {
            handleGetFeedBackButton(urlParams.postId);
          } else if (str === "autoSave") {
            setAutoSaveText(
              "Auto-saved at " +
              moment().format("DD/MM/YYYY, hh:mm:ss A") +
              (files?.length > 0
                ? ". Auto save doesn't includes attachment."
                : ".")
            );
          } else if (str === "viewPastFeedBack") {
            history.push(url);
          } else if (str === "respond") {
            if (taskId > 0 && urlParams.postId > 0) {
              let attachmentIds = [];
              attachmentIds.push(urlParams.postId);
              try {
                await axios.post(
                  serverUrl.LearningResponse + `/${taskId}`,
                  {
                    attachments: attachmentIds,
                  }
                );
              } catch (err) {
                tokenAuthorize(err?.response?.status);
              }
            }
            history.push(prevPage, { taskId });
            Swal.fire({
              title: "Success",
              text: "Post has been updated",
              icon: "success",
            });
          } else {
            if (quickPoll.length != 0) {
              setisOpenQuickPoll(true);
            } else {
              history.push("/journal");
              Swal.fire({
                title: "Success",
                text: "Post has been updated",
                icon: "success",
              });
            }
          }
        })
        .catch((err) => {
          tokenAuthorize(err?.response?.status);
        });
    }
  };

  useEffect(() => {
    if (shouldCheckFiles) {
      if (files.length > 0) {
        dispatch(getUserNavigationConfrimPopup(true));
      } else {
        dispatch(getUserNavigationConfrimPopup(false));
      }
      setShouldCheckFiles(false);
    }
  }, [files, shouldCheckFiles]);

  const validateForm = () => {
    if (post.title.length === 0)
      return { title: "Warning", text: "Please enter a post title" };
    return null;
  };
  const addEdit = (str, url) => {
    const validationResults = validateForm();
    if (validationResults !== null) {
      Swal.fire({
        heightAuto: false,
        title: validationResults.title,
        text: validationResults.text,
        icon: "warning",
      });
      return;
    }
    if (str === "repond") {
      setSaveButtonDisable(true);
    }
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    sourceRef.current = source;
    if (featImgFile || files.length > 0) {
      if (featImgFile) {
        let imgPath = {
          image: featImgFile,
          extension: "jpg",
        };
        axios
          .post(
            serverUrl.UploadBase64,
            imgPath
            // { headers: { 'Content-Type': 'multipart/form-data' } }
          )
          .then((resp) => {
            const attachmentFormData = new FormData();
            const imagePath = serverUrl.Base + resp.data.path;

            files.forEach((file) => {
              attachmentFormData.append("file", file, file.name);
            });
            if (files?.length > 0 && str !== "autoSave") {
              return axios
                .post(serverUrl.UploadMultipleFiles, attachmentFormData, {
                  headers: { "Content-Type": "multipart/form-data" },
                  cancelToken: source.token,
                  onUploadProgress: (progressEvent) => {
                    const percentCompleted =
                      str == "autoSave"
                        ? 0
                        : Math.round(
                          (progressEvent.loaded * 100) / progressEvent.total
                        );
                    setUploadProgress(percentCompleted); // Use a state or variable to store progress
                  },
                })
                .then((resp) => {
                  const attachments = resp.data.map(
                    (storedFile) => serverUrl.Base + storedFile.path
                  );
                  setFiles([]);
                  submitPost(imagePath, attachments, str, url);
                  setUploadProgress(0);
                })
                .catch((err) => {
                  if (axios.isCancel(err)) {
                    console.log(err);
                  } else {
                    console.error(err);
                  }
                  setUploadProgress(0);
                  return null;
                })
                .finally(() => {
                  sourceRef.current = null;
                });
            } else {
              submitPost(imagePath, "", str, url);
            }
          })
          .catch((err) => {
            tokenAuthorize(err?.response?.status);
            console.log(err);
          });
      } else {
        const attachmentFormData = new FormData();
        files.forEach((file) => {
          attachmentFormData.append("file", file, file.name);
        });
        if (str !== "autoSave") {
          return axios
            .post(serverUrl.UploadMultipleFiles, attachmentFormData, {
              headers: { "Content-Type": "multipart/form-data" },
              cancelToken: source.token,
              onUploadProgress: (progressEvent) => {
                const percentCompleted =
                  str == "autoSave"
                    ? 0
                    : Math.round(
                      (progressEvent.loaded * 100) / progressEvent.total
                    );
                setUploadProgress(percentCompleted); // Use a state or variable to store progress
              },
            })
            .then((resp) => {
              const attachments = resp?.data?.map(
                (storedFile) => serverUrl.Base + storedFile.path
              );
              setUploadProgress(0);
              setFiles([]);
              submitPost("", attachments, str, url);
            })
            .catch((err) => {
              if (axios.isCancel(err)) {
                console.log(err);
              } else {
                console.error(err);
              }
              setUploadProgress(0);
              return null;
            })
            .finally(() => {
              sourceRef.current = null;
            });
        } else {
          submitPost("", "", str, url);
        }
      }
    } else {
      submitPost("", "", str, url);
    }
  };
  const discardPost = () => {
    if (userNavigatingConfrimPopup) {
      Swal.fire({
        heightAuto: false,
        title: "Changes not saved",
        text: "Are you sure to leave this page?",
        icon: "warning",
        showCancelButton: false,
        showDenyButton: true,
        confirmButtonText: "Confirm",
        denyButtonText: "Cancel",
        confirmButtonColor: "#3085d6",
        denyButtonColor: "#c1c1c1",
      }).then((result) => {
        if (result.isConfirmed) {
          localStorage.removeItem("journalSave");
          history.push("/journal");
        }
      });
    } else {
      localStorage.removeItem("journalSave");
      history.push("/journal");
    }
  };
  const renderImage = (fileObject) => {
    fileObject.image().then((img) => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const maxWidth = 256;
      const maxHeight = 256;
      const ratio = Math.min(maxWidth / img.width, maxHeight / img.height);
      const width = (img.width * ratio + 0.5) | 0;
      const height = (img.height * ratio + 0.5) | 0;
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);
      canvas.toBlob((blob) => {
        // const resizedFile = new File([blob], featImage.name, fileObject);
        // setFeatImage(URL.createObjectURL(resizedFile))
        //handleChangeImage(resizedFile);
      });
    });
  };

  const removeLocation = (e) => {
    setPost({
      ...post,
      location: { label: "", value: "" },
    });
    dispatch(getUserNavigationConfrimPopup(true));
  };

  const handleFeatImgChange = (e) => {
    const fileObject = e.target.files[0];
    if (!fileObject) return;
    setFeatImgFile(fileObject);
    setPost({
      ...post,
      cover: fileObject,
    });
    //renderImage(fileObject);
  };

  // const handleImageUpload = () => {
  //     featImageRef.current.value = "";
  //     featImageRef.current.click()
  // }

  const handleImageUpload = () => {
    setisOpenModal(true);
  };

  const handleFileUpload = () => {
    uploaderRef.current.value = "";
    uploaderRef.current.click();
  };

  const setfeatureImage = (image) => {
    setFeatImgFile(image);
    setPost({
      ...post,
      cover: image,
    });
    dispatch(getUserNavigationConfrimPopup(true));
  };

  const uploadImageCallBack = (imageFile) => {
    return new Promise((resolve, reject) => {
      Resizer.imageFileResizer(
        imageFile,
        1200,
        515,
        "PNG",
        100,
        0,
        (uri) => {
          const formData = new FormData();
          formData.append("file", imageFile);
          axios
            .post(serverUrl.UploadFile, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((resp) => {
              const imageUrl = serverUrl.Base + resp.data.data.path;
              resolve({ data: { link: imageUrl } });
            })
            .catch((err) => {
              tokenAuthorize(err?.response?.status);
              console.log(err);
            });
        },
        "base64"
      );
    });
  };
  const [review, setReview] = useState(false);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setModelError("Please choose any of the model to review!");
  };
  const handleModalChange = (value) => {
    setModel(value);
    setDefaultModelVal(value);
    setReview(false);
  };

  const handleReflectionReview = () => {
    setisOpenModalReflectionReview(
      isOpenModalReflectionReview ? !isOpenModalReflectionReview : true
    );
  };
  const handleQuickPollReview = () => {
    setisOpenQuickPoll(isOpenQuickPoll ? !isOpenQuickPoll : true);
  };
  const handleGetFeedBack = () => {
    let validatemessage = validatePage();
    if (!validatemessage) {
      setfeedbackButtonText("Processing...");
      setModelError("Please wait while we generate your feedback.");
      dispatch(getReflectionFeedbackProcessing(true));
      addEdit("autoReflectionSave");
      setReview(false);
    } else {
      Swal.fire({
        heightAuto: false,
        title: "Warning",
        icon: "warning",
        text: validatemessage,
      }).then((result) => { });
      return;
    }
  };
  const validatePage = () => {
    if (!modelVal && !contentEditor && post.title.length === 0)
      return "Please enter the post title, content and model";
    if (post.title.length === 0) return "Please enter a post title";
    if (!contentEditor) return "Please enter the content";
    if (!modelVal) return "Please choose the model";
    return null;
  };
  const handleGetFeedBackButton = (postID) => {
    setfeedbackButtonText("Processing...");
    dispatch(getReflectionFeedbackProcessing(true));
    //Reflection Feedback Post API
    let data = {
      model_id: modelVal,
      reflection_id: postID,
      reflection_text: contentEditor,
    };
    axios
      .post(serverUrl.ReflectionFeedBack, data)
      .then((response) => {
        setfeedbackButtonText("Get Feedback");
        dispatch(getReflectionFeedbackProcessing(false));
        if (response.status === 200) {
          try {
            setReview(true);
            setHtmlEvaluation(response?.data?.evaluation);
            axios
              .get(serverUrl.ReflectionFeedBackHistory + "/" + postID)
              .then((resp) => {
                if (resp.status === 200) {
                  setFeedbackHistory(resp.data.results);
                  setModel(
                    resp.data.results[resp.data.results.length - 1].model_id
                  );
                  //setDefaultModelVal(resp.data.results[resp.data.results.length - 1].model_id);
                  setReview(true);
                }
              })
              .catch((err) => {
                tokenAuthorize(err?.response?.status);
                goBack("", "");
              });
            let poll_id = reflectionFeedbackModel?.reflection?.find(
              (x) => x.id === modelVal
            )?.poll_id;
            if (!response?.data?.is_poll_submitted && poll_id) {
              //Getting Poll Response
              axios
                .get(serverUrl.ReflectionFeedbackPollGroups + "/" + poll_id)
                .then((resp) => {
                  if (resp.status === 200) {
                    try {
                      setQuickPoll(
                        resp.data?.results.map((item) => ({
                          ...item,
                          model_id: modelVal,
                          poll_id: poll_id,
                          response_text: "",
                          response_rating: 0,
                          rating_text: "",
                        }))
                      );
                    } catch (err) {
                      console.log(err);
                      // setLoading(false);
                    }
                  }
                })
                .catch((err) => {
                  tokenAuthorize(err?.response?.status);
                  goBack("", "");
                });
            } else {
              setQuickPoll([]);
            }
          } catch (err) {
            setReview(false);
            setfeedbackButtonText("Get Feedback");
            dispatch(getReflectionFeedbackProcessing(false));
            setHtmlEvaluation(err);
            console.log(err);
          }
        }
      })
      .catch((err) => {
        setfeedbackButtonText("Get Feedback");
        dispatch(getReflectionFeedbackProcessing(false));
        setReview(false);
        setModelError(err?.response?.data?.response?.message);
        tokenAuthorize(err?.response?.status);
        setHtmlEvaluation("");
      });
  };

  const handleFeedBackHistory = (url) => {
    dispatch(getReflectionFeedbackHistory(true));
    addEdit("viewPastFeedBack", url);
  };

  const handleCancelUpload = () => {
    sourceRef.current.cancel("Upload canceled by user");
    sourceRef.current = null;
    setUploadProgress(0);
  };

  const Popup = () => {
    const style = `${show ? "flex" : "hidden"
      } fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 z-50 justify-center items-center`;

    return (
      <div className={style} onClick={(e) => e.stopPropagation()}>
        <section className="">
          <Card className="rounded-lg bg-white shadow-lg h-full max-h-screen overflow-hidden">
            {/* Header */}
            <div className="relative flex items-center justify-between px-5 py-3 border-b border-gray-200">
              <div className="font-bold text-base">Error Files</div>
              <CROSS_BLACK_ICON
                className="w-6 h-6 cursor-pointer hover:opacity-60"
                onClick={() => setShow(false)}
              />
            </div>

            {/* Scrollable content area */}
            <div className="overflow-y-auto px-3 py-4" ref={modalRef}>
              <div className="space-y-2">
                {errorFileNotExtention.length > 0 && (
                  <div>
                    <p className="text-sm px-2 text-justify">
                      The following files are not supported:
                    </p>
                    <ul className="list-disc list-inside text-red-500 text-sm px-5">
                      {errorFileNotExtention.map((file, index) => (
                        <li key={`ext-${index}`} className="py-1">
                          {file.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {errorFileSizeLimits.length > 0 && (
                  <div>
                    <p className="text-sm px-2 text-justify">
                      The following files exceed the size limit of{" "}
                      {attachmentFileSize} MB:
                    </p>
                    <ul className="list-disc list-inside text-red-500 text-sm px-5">
                      {errorFileSizeLimits.map((file, index) => (
                        <li key={`size-${index}`} className="py-1">
                          {file.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </Card>
        </section>
      </div>
    );
  };

  if (isLoading)
    return (
      <div className="w-full flex justify-center">
        <img src={staticFiles.loading} alt="Loading..." className="w-10 h-10" />
      </div>
    );
  else
    return (
      <div className="p-2 sm:p-6">
        <Popup />
        {isOpenModal && (
          <ModalFeaturedImage
            showModalFeature={isOpenModal}
            setshowModalFeature={setisOpenModal}
            setfeatureImage={setfeatureImage}
          />
        )}
        <ModalReflectionReview
          showModalFeature={isOpenModalReflectionReview}
          setshowModalFeature={handleReflectionReview}
          htmlContent={htmlEvaluation}
          quickPollContent={quickPoll}
          updatedData={setQuickPoll}
        />
        <ModalQuickPoll
          showModalFeature={isOpenQuickPoll}
          setshowModalFeature={handleQuickPollReview}
          quickPollContent={quickPoll}
          updatedData={setQuickPoll}
          refelectionBot={""}
        />
        {deviceWidth > 1 ? (
          <div className={"h-auto"}>
            <PanelGroup
              className={`flex flex-col md:flex-row w-full overflow-unset`}
              autoSaveId={`${reflectionFeedbackModel?.reflection?.length !== 0
                ? "feedbackPanels_" + localStorage.getItem("user_id")
                : ""
                }`}
              localStorage={
                reflectionFeedbackModel?.reflection?.length !== 0
                  ? resizeLocalStorage
                  : ""
              }
              direction={deviceWidth > 768 ? "horizontal" : "vertical"}
            >
              <Panel
                onResize={() => {
                  if (tabsRef.current) {
                    tabsRef.current.updateIndicator();
                  }
                }}
                className="overflow-unset"
                defaultSize={70}
                minSize={40}
              >
                <div ref={leftContainerRef} className="w-full flex flex-col min-h-[600px]">
                  <div className="w-full text-blue-500 font-semibold mb-2 flex justify-between items-center">
                    <div
                      className={`rounded-lg p-0 flex gap-1 ml-1 items-center w-max ${feedbackButtonText !== "Get Feedback"
                        ? "cursor-not-allowed pointer-events-none"
                        : "cursor-pointer"
                        }`}
                      onClick={discardPost}
                    >
                      <KeyboardBackspaceIcon
                        style={{ fontSize: "28px" }}
                        className=" primaryIcon"
                      />
                      <h1 className="text-md blueColor font-semibold">Back</h1>
                    </div>
                    {/* <div
                      className={`rounded-lg p-0 flex gap-1 items-center w-max cursor-pointer`}
                      onClick={goBack}
                    >
                      <KeyboardBackspaceIcon
                        style={{ fontSize: "28px" }}
                        className=" primaryIcon"
                      />
                      <h1 className="text-lg blueColor font-semibold">Back</h1>
                    </div> */}
                    <div className="flex items-center  justify-around gap-2">
                      <p
                        className={`text-gray-500 text-xs pt-2 autoSaveMessage ${isAutoSaveVisible ? "show" : "hide"
                          }`}
                      >
                        {autoSavedText}
                      </p>
                      {props.location?.state?.data == "journal" ? (
                        <>
                          <ButtonCommonTopNew
                            className={`rounded-lg px-5 py-2 text-xs flex items-center w-max cursor-pointer`}
                            onClick={() => addEdit("respond")}
                          >
                            Save & Respond
                          </ButtonCommonTopNew>
                          <ButtonCommonGreen
                            className={`rounded-lg text-xs px-5 py-2 flex items-center w-max cursor-pointer`}
                            onClick={() => addEdit("journal")}
                          >
                            Save to Journal
                          </ButtonCommonGreen>
                          {/* <ButtonCommon title="Save & Respond" className={"px-2 py-3"} width="full" onClick={() => addEdit("respond")} textStyle="lg:whitespace-nowrap md:whitespace-nowrap xl:whitespace-nowrap" />
                                            <ButtonGreen className={"px-2"} title="Save to Journal" bgColor="bg-green hover:bg-green-600" width="full" onClick={() => addEdit("journal")} /> */}
                        </>
                      ) : (
                        <ActionButton
                          className={"py-2 px-4 h-10"}
                          buttonStyle="w-full"
                          textStyle=""
                          style="px-8 py-4"
                          title="Save"
                          width="full"
                          disabled={
                            saveButtonDisable ||
                              feedbackButtonText !== "Get Feedback"
                              ? true
                              : false
                          }
                          onClick={() => addEdit("respond")}
                        />
                      )}
                      <ModalShare
                        show={showModal}
                        handleClose={() => setShowModal(false)}
                      />
                    </div>
                  </div>
                  <input
                    className="bg-transparent w-full rounded-sm mb-1 mt-0 text-xl outline-none"
                    type="text"
                    placeholder="Enter post title"
                    value={post.title}
                    onChange={(e) => {
                      setPost({
                        ...post,
                        title: e.target.value,
                      });
                      dispatch(getUserNavigationConfrimPopup(true));
                    }}
                  />
                  {post.tags.length > 0 && (
                    <ul className="flex flex-wrap gap-2 my-1">
                      {post.tags.map((tag, index) => (
                        <ListButton
                          key={index}
                          className="flex justify-center items-center bg-blue-500 text-white px-2 rounded-md"
                        >
                          <span>{tag}</span>
                          <IoMdCloseCircle
                            className="ml-2"
                            onClick={() => removeTags(index)}
                          />
                        </ListButton>
                      ))}
                    </ul>
                  )}
                  <input
                    type="text"
                    placeholder="Press enter to add tags..."
                    onKeyUp={(e) =>
                      e.key === "Enter" || e.key === " " ? addTags(e) : null
                    }
                    className="border-none mt-1 outline-none mb-2 bg-transparent"
                  />
                  {
                    // toolbar:
                    // 'undo redo | formatselect | bold italic backcolor | ' +
                    // 'alignleft aligncenter alignright alignjustify | ' +
                    // 'bullist numlist outdent indent | removeformat | ' +
                    // 'table tabledelete | tableprops tablerowprops tablecellprops | ' +
                    // 'tableinsertrowbefore tableinsertrowafter tabledeleterow | ' +
                    // 'tableinsertcolbefore tableinsertcolafter tabledeletecol',
                  }
                  <DPEditor
                    content={contentEditor}
                    setContent={handleEditorChange}
                    height={600}
                  />
                </div>
              </Panel>
              <PanelResizeHandle
                className={`w-2 pl-4 ${reflectionFeedbackModel?.reflection?.length === 0
                  ? "hidden"
                  : "flex"
                  } justify-center items-center  ${deviceWidth < 768 ? "hidden" : ""
                  } `}
              >
                <DragIndicatorIcon />
              </PanelResizeHandle>
              <Panel
                onResize={(size) => {
                  if (tabsRef.current) {
                    tabsRef.current.updateIndicator();
                  }
                  if (size > 30) {
                    setButtonWrap(true);
                  } else {
                    setButtonWrap(false);
                  }
                }}
                className="overflow-unset tabs-container"
                defaultSize={30}
                minSize={30}
              >
                <div className="flex-1 flex flex-col">
                  {reflectionFeedbackModel?.reflection?.length === 0 ? (
                    <div className="md:pl-4 md:mt-2 sm:mt-2">
                      {/* <div className="md:pl-4 md:mt-14 sm:mt-2"> */}
                      <div className="flex flex-col mb-8">
                        <label>Featured Image</label>
                        {/* <div
                                                className="cursor-pointer flex items-center justify-center h-32 border-2 border-gray-400 bg-gray-200 border-dashed overflow-hidden"
                                                onClick={() => handleImageUpload()}
                                            >
                                                <img
                                                    className={post.cover.length > 0 ? "w-full" : "hidden"}
                                                    src={post.cover} alt="Featured"
                                                />
                                                <p className={"text-gray-600" + (post.cover.length === 0 ? "" : " hidden")}>
                                                    Set featured image
                                                </p>
                                            </div>
                                            <div className={"flex justify-between text-sm" + (post.cover.length === 0 ? " hidden" : "")}>
                                                <span
                                                    className="cursor-pointer"
                                                    onClick={() => handleImageUpload()}
                                                >Change</span>
                                                <span className="cursor-pointer"
                                                    onClick={() => {
                                                        setPost({
                                                            ...post,
                                                            cover: ""
                                                        });
                                                        dispatch(getUserNavigationConfrimPopup(true));
                                                        setFeatImgFile(null)
                                                    }}
                                                >Remove</span>
                                            </div> */}
                        <div
                          className="mt-2 blue-borde shadow-sm border20px cursor-pointer backGroundColor  flex items-center justify-center min-h-36 max-h-auto border20px "
                          // className="cursor-pointer flex items-center justify-center h-32 border-2 border-gray-400 bg-gray-200 border-dashed overflow-hidden"
                          onClick={() => handleImageUpload()}
                        >
                          <img
                            className={
                              post.cover.length > 0
                                ? "w-full h-auto border20px"
                                : "hidden"
                            }
                            src={post.cover}
                            alt="Featured"
                          />
                          <div
                            className={
                              "" +
                              (post.cover.length === 0
                                ? "colorBlack mx-2 my-4 border20px w-full h-36 flex-col flex items-center justify-center "
                                : " hidden")
                            }
                          >
                            <ButtonCommonTopNew className="p-3 rounded-lg items-center justify-center flex">
                              <CollectionsIcon
                                style={{ fontSize: "30px" }}
                                className="blueColor"
                              />
                            </ButtonCommonTopNew>
                            <p className="mt-2 text-md blueColor">
                              Set featured image
                            </p>
                          </div>
                        </div>
                        <div
                          className={
                            "flex justify-between text-sm mt-1" +
                            (post.cover.length === 0 ? " hidden" : "")
                          }
                        >
                          <span
                            className="cursor-pointer blueColor"
                            onClick={() => handleImageUpload()}
                          >
                            Change
                          </span>
                          <span
                            className="cursor-pointer deleteColor"
                            onClick={() => {
                              setPost({
                                ...post,
                                cover: "",
                              });
                              setFeatImgFile(null);
                              dispatch(getUserNavigationConfrimPopup(true));
                            }}
                          >
                            Remove
                          </span>
                        </div>
                      </div>
                      <div className="flex flex-col mb-2">
                        <label>Values/Competencies</label>
                        <Select
                          value={post.values}
                          placeholder="Select"
                          options={valOptions}
                          className="p-1 "
                          filterOption={(option, inputValue) =>
                            option.data.label
                              .toLowerCase()
                              .includes(inputValue.toLowerCase()) ||
                            option.data.filterValue
                              .toLowerCase()
                              .includes(inputValue.toLowerCase())
                          }
                          onChange={(e) => {
                            setPost({
                              ...post,
                              values: e,
                            });
                            dispatch(getUserNavigationConfrimPopup(true));
                          }}
                          components={{
                            MultiValue: MultiValueCustom,
                            MultiValueRemove: () => null,
                            IndicatorSeparator: () => null,
                          }}
                          styles={{
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: "transparent", // so our custom div takes over
                              padding: 0,
                              maxWidth: '220px',
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              padding: 0,
                            }),
                            multiValueRemove: (base) => ({
                              ...base,
                              padding: 0,
                            }),
                            valueContainer: (base, state) => ({
                              ...base,
                              flexWrap: 'wrap',
                              padding:
                                state.getValue().length > 0
                                  ? "4px 8px"
                                  : "0px 8px",
                            }),
                            indicatorsContainer: (base) => ({
                              ...base,
                              padding: 0, // remove container padding (optional if needed)
                              margin: 0,
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              ...base,
                              paddingLeft: 0, // 👈 remove only left padding
                            }),
                            clearIndicator: (base) => ({
                              ...base,
                              paddingLeft: 0, // 👈 remove only left padding
                            }),
                          }}
                          isMulti
                        />
                      </div>
                      <div className="flex flex-col mb-2">
                        <label>Courses</label>
                        <Select
                          value={post.courses}
                          placeholder="Select"
                          options={couOptions}
                          filterOption={(option, inputValue) =>
                            option.data.label
                              .toLowerCase()
                              .includes(inputValue.toLowerCase()) ||
                            option.data.filterValue
                              .toLowerCase()
                              .includes(inputValue.toLowerCase())
                          }
                          className="p-1"
                          onChange={(e) => {
                            setPost({
                              ...post,
                              courses: e,
                            });
                            dispatch(getUserNavigationConfrimPopup(true));
                          }}
                          isMulti
                          components={{
                            MultiValue: MultiValueCustom,
                            MultiValueRemove: () => null,
                            IndicatorSeparator: () => null,
                          }}
                          styles={{
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: "transparent", // so our custom div takes over
                              padding: 0,
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              padding: 0,
                            }),
                            multiValueRemove: (base) => ({
                              ...base,
                              padding: 0,
                            }),
                            valueContainer: (base, state) => ({
                              ...base,
                              padding:
                                state.getValue().length > 0
                                  ? "4px 8px"
                                  : "0px 8px",
                            }),
                            indicatorsContainer: (base) => ({
                              ...base,
                              padding: 0, // remove container padding (optional if needed)
                              margin: 0,
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              ...base,
                              paddingLeft: 0, // 👈 remove only left padding
                            }),
                            clearIndicator: (base) => ({
                              ...base,
                              paddingLeft: 0, // 👈 remove only left padding
                            }),
                          }}
                        />
                      </div>
                      <div className="flex flex-col mb-2">
                        <label>Topics</label>
                        <Select
                          value={post.events}
                          placeholder="Select"
                          options={evOptions}
                          className="p-1"
                          onChange={(e) => {
                            setPost({
                              ...post,
                              events: e,
                            });
                            dispatch(getUserNavigationConfrimPopup(true));
                          }}
                          isMulti
                          components={{
                            MultiValue: MultiValueCustom,
                            MultiValueRemove: () => null,
                            IndicatorSeparator: () => null,
                          }}
                          styles={{
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: "transparent", // so our custom div takes over
                              padding: 0,
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              padding: 0,
                            }),
                            multiValueRemove: (base) => ({
                              ...base,
                              padding: 0,
                            }),
                            valueContainer: (base, state) => ({
                              ...base,
                              padding:
                                state.getValue().length > 0
                                  ? "4px 8px"
                                  : "0px 8px",
                            }),
                            indicatorsContainer: (base) => ({
                              ...base,
                              padding: 0, // remove container padding (optional if needed)
                              margin: 0,
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              ...base,
                              paddingLeft: 0, // 👈 remove only left padding
                            }),
                            clearIndicator: (base) => ({
                              ...base,
                              paddingLeft: 0, // 👈 remove only left padding
                            }),
                          }}
                        />
                      </div>
                      <div className="flex flex-col mb-2">
                        <label>Location</label>
                        <div className="p-1">
                          <GooglePlacesAutocomplete
                            apiKey="AIzaSyAY2jkSWLuXmTltSC6q1CfTCMdGLvphKSY"
                            selectProps={{
                              value: post.location,
                              onChange: (e) => {
                                setPost({
                                  ...post,
                                  location: e,
                                });
                                dispatch(getUserNavigationConfrimPopup(true));
                              },
                              components: {
                                IndicatorSeparator: () => null, // 👈 removes the vertical line
                              },
                              styles: {
                                indicatorsContainer: (base) => ({
                                  ...base,
                                  padding: 0,
                                }),
                              },
                            }}
                          />
                        </div>
                        {post.location && post.location.label.length > 0 && (
                          <label
                            className="text-right text-sm text-gray-600 cursor-pointer deleteColor"
                            onClick={removeLocation}
                          >
                            Remove location
                          </label>
                        )}
                      </div>
                      <div className="">
                        <p className="mb-2">Attachments</p>
                        <div className="borderGray backGroundColor  p-4 rounded-2xl flex items-center">
                          <ButtonCommonTopNew
                            className=" rounded-lg px-3 py-2 cursor-pointer items-center justify-center filter pointer text-sm w-max"
                            onClick={() => handleFileUpload()}
                          >
                            Browse
                          </ButtonCommonTopNew>
                          <span className="text-sm ml-3 blueColor">
                            Upload attachments
                          </span>
                        </div>
                        <input
                          className="hidden"
                          ref={uploaderRef}
                          type="file"
                          accept={attachmentExtension}
                          multiple
                          onChange={(e) => addFiles(e)}
                        />
                      </div>
                      {post.attachments && post.attachments.length > 0 && (
                        <>
                          <div className="flex flex-wrap gap-2">
                            {post.attachments &&
                              post.attachments.map((item, idx) => {
                                let itemName = item;
                                if (itemName) {
                                  const lastSlash = item.lastIndexOf("/");
                                  if (lastSlash !== -1) {
                                    const fileName =
                                      item?.slice(item.lastIndexOf("/") + 1) ||
                                      "";
                                    const finalName = fileName.includes("-")
                                      ? fileName.slice(
                                        fileName.indexOf("-") + 1
                                      )
                                      : fileName;
                                    itemName = finalName;
                                  }
                                  return (
                                    <DivBadge
                                      key={idx}
                                      className="flex items-center rounded-lg px-3 justify-center w-max"
                                    >
                                      <a
                                        href={item}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex text-sm p-1 nav-navigate"
                                      >
                                        <div className=" text-white">
                                          {itemName}
                                        </div>
                                      </a>
                                      <div
                                        onClick={() => removeFile(idx, item)}
                                      >
                                        <AiOutlineCloseCircle className="cursor-pointer text-white" />
                                      </div>
                                    </DivBadge>
                                  );
                                }
                                return null;
                              })}
                          </div>
                        </>
                      )}
                    </div>
                  ) : (
                    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
                      <NavTabs
                        menuLinks={[
                          {
                            title: "Meta Tag",
                            index: 0,
                            onChange: (e) => {
                              handleChange(e, 0);
                            },
                          },
                          {
                            title: "Review",
                            index: 1,
                            onChange: (e) => {
                              handleChange(e, 1);
                            },
                          },
                        ]}
                        value={value}
                      />
                      {/* <Tabs action={tabsRef} key={deviceWidth} value={value} onChange={handleChange} sx={{ '& .MuiTabs-flexContainer': { justifyContent: "space-around", borderBottom: '1px solid #2084D4' } }}>
                                            <Tab className={`p-0 gap-1 ${feedbackButtonText !== "Get Feedback" ? 'cursor-not-allowed pointer-events-none' : 'cursor-pointer'}`} icon={<img src={MetaTagIcon} alt="Meta Icon" />} label="Meta tag" sx={{ minHeight: '73px' }} />
                                            <Tab className="p-0 gap-0" icon={<img src={ReviewTabIcon} alt="Review Icon" />} label="Review" sx={{ minHeight: '73px' }} />
                                        </Tabs> */}
                      <TabPanel value={value} index={0}>
                        <div className="flex flex-col mb-4">
                          <label>Featured Image</label>
                          <div
                            className="mt-2 blue-borde shadow-sm border20px cursor-pointer backGroundColor  flex items-center justify-center min-h-36 max-h-auto border20px "
                            // className="cursor-pointer flex items-center justify-center h-32 border-2 border-gray-400 bg-gray-200 border-dashed overflow-hidden"
                            onClick={() => handleImageUpload()}
                          >
                            <img
                              className={
                                post.cover.length > 0
                                  ? "w-full h-auto border20px"
                                  : "hidden"
                              }
                              src={post.cover}
                              alt="Featured"
                            />
                            <div
                              className={
                                "" +
                                (post.cover.length === 0
                                  ? "colorBlack mx-2 my-4 border20px w-full h-36 flex-col flex items-center justify-center "
                                  : " hidden")
                              }
                            >
                              <ButtonCommonTopNew className="p-3 rounded-lg items-center justify-center flex">
                                <CollectionsIcon
                                  style={{ fontSize: "30px" }}
                                  className="blueColor"
                                />
                              </ButtonCommonTopNew>
                              <p className="mt-2 text-md blueColor">
                                Set featured image
                              </p>
                            </div>
                          </div>
                          <div
                            className={
                              "flex justify-between text-sm mt-1" +
                              (post.cover.length === 0 ? " hidden" : "")
                            }
                          >
                            <span
                              className="cursor-pointer blueColor"
                              onClick={() => handleImageUpload()}
                            >
                              Change
                            </span>
                            <span
                              className="cursor-pointer deleteColor"
                              onClick={() => {
                                setPost({
                                  ...post,
                                  cover: "",
                                });
                                setFeatImgFile(null);
                                dispatch(getUserNavigationConfrimPopup(true));
                              }}
                            >
                              Remove
                            </span>
                          </div>
                        </div>
                        <div className="flex flex-col mb-2">
                          <label>Values/Competencies</label>
                          <Select
                            filterOption={(option, inputValue) =>
                              option.data.label
                                .toLowerCase()
                                .includes(inputValue.toLowerCase()) ||
                              option.data.filterValue
                                .toLowerCase()
                                .includes(inputValue.toLowerCase())
                            }
                            value={post.values}
                            options={valOptions}
                            className="py-1"
                            placeholder="Select"
                            onChange={(e) => {
                              setPost({
                                ...post,
                                values: e,
                              });
                              dispatch(getUserNavigationConfrimPopup(true));
                            }}
                            components={{
                              MultiValue: MultiValueCustom,
                              MultiValueRemove: () => null,
                              IndicatorSeparator: () => null,
                            }}
                            styles={{
                              multiValue: (base) => ({
                                ...base,
                                backgroundColor: "transparent", // so our custom div takes over
                                padding: 0,
                              }),
                              multiValueLabel: (base) => ({
                                ...base,
                                padding: 0,
                              }),
                              multiValueRemove: (base) => ({
                                ...base,
                                padding: 0,
                              }),
                              valueContainer: (base, state) => ({
                                ...base,
                                padding:
                                  state.getValue().length > 0
                                    ? "4px 8px"
                                    : "0px 4px",
                              }),
                              indicatorsContainer: (base) => ({
                                ...base,
                                padding: 0, // remove container padding (optional if needed)
                                margin: 0,
                              }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                ...base,
                                paddingLeft: 0, // 👈 remove only left padding
                              }),
                              clearIndicator: (base) => ({
                                ...base,
                                paddingLeft: 0, // 👈 remove only left padding
                              }),
                            }}
                            isMulti
                          />
                        </div>
                        <div className="flex flex-col mb-2">
                          <label>Courses</label>
                          <Select
                            value={post.courses}
                            options={couOptions}
                            filterOption={(option, inputValue) =>
                              option.data.label
                                .toLowerCase()
                                .includes(inputValue.toLowerCase()) ||
                              option.data.filterValue
                                .toLowerCase()
                                .includes(inputValue.toLowerCase())
                            }
                            placeholder="Select"
                            className="py-1"
                            onChange={(e) => {
                              setPost({
                                ...post,
                                courses: e,
                              });
                              dispatch(getUserNavigationConfrimPopup(true));
                            }}
                            isMulti
                            components={{
                              MultiValue: MultiValueCustom,
                              MultiValueRemove: () => null,
                              IndicatorSeparator: () => null,
                            }}
                            styles={{
                              multiValue: (base) => ({
                                ...base,
                                backgroundColor: "transparent", // so our custom div takes over
                                padding: 0,
                              }),
                              multiValueLabel: (base) => ({
                                ...base,
                                padding: 0,
                              }),
                              multiValueRemove: (base) => ({
                                ...base,
                                padding: 0,
                              }),
                              valueContainer: (base, state) => ({
                                ...base,
                                padding:
                                  state.getValue().length > 0
                                    ? "4px 8px"
                                    : "0px 8px",
                              }),
                              indicatorsContainer: (base) => ({
                                ...base,
                                padding: 0, // remove container padding (optional if needed)
                                margin: 0,
                              }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                ...base,
                                paddingLeft: 0, // 👈 remove only left padding
                              }),
                              clearIndicator: (base) => ({
                                ...base,
                                paddingLeft: 0, // 👈 remove only left padding
                              }),
                            }}
                          />
                        </div>
                        <div className="flex flex-col mb-2">
                          <label>Topics</label>
                          <Select
                            value={post.events}
                            options={evOptions}
                            className="py-1"
                            placeholder="Select"
                            onChange={(e) => {
                              setPost({
                                ...post,
                                events: e,
                              });
                              dispatch(getUserNavigationConfrimPopup(true));
                            }}
                            isMulti
                            components={{
                              MultiValue: MultiValueCustom,
                              MultiValueRemove: () => null,
                              IndicatorSeparator: () => null,
                            }}
                            styles={{
                              multiValue: (base) => ({
                                ...base,
                                backgroundColor: "transparent", // so our custom div takes over
                                padding: 0,
                              }),
                              multiValueLabel: (base) => ({
                                ...base,
                                padding: 0,
                              }),
                              multiValueRemove: (base) => ({
                                ...base,
                                padding: 0,
                              }),
                              valueContainer: (base, state) => ({
                                ...base,
                                padding:
                                  state.getValue().length > 0
                                    ? "4px 8px"
                                    : "0px 8px",
                              }),
                              indicatorsContainer: (base) => ({
                                ...base,
                                padding: 0, // remove container padding (optional if needed)
                                margin: 0,
                              }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                ...base,
                                paddingLeft: 0, // 👈 remove only left padding
                              }),
                              clearIndicator: (base) => ({
                                ...base,
                                paddingLeft: 0, // 👈 remove only left padding
                              }),
                            }}
                          />
                        </div>
                        <div className="flex flex-col mb-2">
                          <label>Location</label>
                          <div className="py-1">
                            <GooglePlacesAutocomplete
                              apiKey="AIzaSyAY2jkSWLuXmTltSC6q1CfTCMdGLvphKSY"
                              selectProps={{
                                value: post.location,
                                onChange: (e) => {
                                  setPost({
                                    ...post,
                                    location: e,
                                  });
                                  dispatch(getUserNavigationConfrimPopup(true));
                                },
                                components: {
                                  IndicatorSeparator: () => null, // 👈 removes the vertical line
                                },
                                styles: {
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    padding: 0,
                                  }),
                                },
                              }}
                            />
                          </div>
                          {post.location && post.location.label.length > 0 && (
                            <label
                              className="text-right text-sm deleteColor text-gray-600 cursor-pointer "
                              onClick={removeLocation}
                            >
                              Remove location
                            </label>
                          )}
                        </div>
                        <p className="mb-2">Attachments</p>
                        <div className="flex flex-col mb-3">
                          <div className="borderGray backGroundColor  p-4 rounded-2xl flex items-center">
                            <ButtonCommonTopNew
                              className=" rounded-lg px-3 py-2 cursor-pointer items-center justify-center filter pointer text-sm w-max"
                              onClick={() => handleFileUpload()}
                            >
                              Browse
                            </ButtonCommonTopNew>
                            <span className="text-sm ml-3 blueColor">
                              Upload attachments
                            </span>
                          </div>

                          <input
                            className="hidden"
                            ref={uploaderRef}
                            type="file"
                            accept={attachmentExtension}
                            multiple
                            onChange={(e) => addFiles(e)}
                          />
                        </div>
                        {post.attachments && post.attachments.length > 0 && (
                          <>
                            <div className="flex flex-wrap gap-2 ">
                              {post.attachments &&
                                post.attachments.map((item, idx) => {
                                  let itemName = item;
                                  if (itemName) {
                                    const lastSlash = item.lastIndexOf("/");
                                    if (lastSlash !== -1) {
                                      const fileName =
                                        item?.slice(
                                          item.lastIndexOf("/") + 1
                                        ) || "";
                                      const finalName = fileName.includes("-")
                                        ? fileName.slice(
                                          fileName.indexOf("-") + 1
                                        )
                                        : fileName;
                                      itemName = finalName;
                                    }
                                    return (
                                      <DivBadge
                                        key={idx}
                                        className="flex items-center rounded-lg px-3 justify-center w-max"
                                      >
                                        <a
                                          href={item}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="flex text-sm p-1 nav-navigate"
                                        >
                                          <div className=" text-white">
                                            {itemName}
                                          </div>
                                        </a>
                                        <div
                                          onClick={() => removeFile(idx, item)}
                                        >
                                          <AiOutlineCloseCircle className="cursor-pointer text-white" />
                                        </div>
                                      </DivBadge>
                                    );
                                  }
                                  return null;
                                })}
                            </div>
                          </>
                        )}
                      </TabPanel>
                      <TabPanel value={value} index={1}>
                        <div className={` w-full flex justify-between gap-2`}>
                          <SelectModalDropDown
                            onChange={handleModalChange}
                            defaultValue={defaultModelVal}
                            className={`${ButtonWrap ? "" : ""}`}
                            option={reflectionFeedbackModel}
                            disabled={
                              feedbackButtonText !== "Get Feedback"
                                ? true
                                : false
                            }
                          />
                          <div
                            className={`${ButtonWrap ? "" : ""
                              } flex-1 flex justify-end`}
                          >
                            <ButtonCommonTopNew
                              className={`rounded-lg fontFamily px-3 text-xs py-1 flex flex-shrink-0 items-center cursor-pointer`}
                              onClick={() => handleGetFeedBack()}
                            >
                              <BsStars
                                style={{ fontSize: "16px" }}
                                className=" blueColor mr-1"
                              />
                              {feedbackButtonText}
                            </ButtonCommonTopNew>
                          </div>
                        </div>
                        <div className="flex-1 flex flex-col min-h-0">
                          <div className="flex mt-2 reviewTab py-2 px-3 justify-between rounded-xl rounded-b-none">
                            <span className="ml-1 fontFamily font-semibold text-sm">
                              Feedback{" "}
                            </span>
                            {modelVal && review && (
                              <img
                                src={ReviewIcon}
                                className="cursor-pointer"
                                onClick={handleReflectionReview}
                              />
                            )}
                          </div>
                          {modelVal && review ? (
                            <div
                              className={`review-container rounded-t-none rounded-xl overflow-auto flex flex-col`}
                              style={{ height: leftHeight > 140 ? `${leftHeight - 140}px` : "auto" }}
                            >
                              <div className="review-section p-2.5">
                                <MarkDownContent
                                  htmlContent={htmlEvaluation}
                                  className={false}
                                  tableHeader={true}
                                />
                              </div>
                              {quickPoll && quickPoll.length != 0 && (
                                <div className="flex reviewTab p-1 px-4 justify-between">
                                  <label className="text-sm font-semibold blackColor">
                                    Quick Poll
                                  </label>
                                </div>
                              )}
                              <div className="px-2.5 pb-2.5">
                                {quickPoll && quickPoll.length != 0 && (
                                  <QuickPoll
                                    data={quickPoll}
                                    updatedData={setQuickPoll}
                                    isOpenQuickPoll={isOpenQuickPoll}
                                  />
                                )}
                              </div>
                            </div>
                          ) : (
                            <div class="review-container p-2.5 rounded-t-none rounded-lg">
                              <div class="review-header  text-sm">
                                {modelError}
                              </div>
                            </div>
                          )}
                        </div>
                        {historyEnabled && feedbackHistory?.length != 0 && (
                          <a
                            className={`blueColor no-underline hover:no-underline text-sm float-right mt-2 ${feedbackButtonText !== "Get Feedback"
                              ? "cursor-not-allowed pointer-events-none"
                              : "cursor-pointer"
                              } `}
                            onClick={() =>
                              handleFeedBackHistory(
                                `/journal/edit/${urlParams.postId}/pastreviewhistory`
                              )
                            }
                          >
                            View past {feedbackHistory?.length} feedback(s)
                          </a>
                        )}
                      </TabPanel>
                    </Box>
                  )}
                </div>
              </Panel>
            </PanelGroup>
          </div>
        ) : (
          <></>
        )}
        <div
          className={`${uploadProgress > 0 && uploadProgress < 100 ? "flex" : "hidden"
            } fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 block z-50`}
          onClick={(e) => e.stopPropagation()}
        >
          <section className="fixed transform -translate-y-2/4 -translate-x-2/4 top-2/4 left-2/4 w-full md:w-3/12 popUpWidth">
            <Card className="h-2/4 rounded-lg overflow-hidden" id="cards">
              <div className="relative flex py-3">
                <div className="w-full font-bold flex items-start px-5">
                  File Uploading In-progress
                </div>
              </div>
              <hr className="text-gray-200" />
              <div
                className="overflow-y-auto h-52 w-full scroll-smooth"
                ref={modalRef}
              >
                <div className="w-full h-1/2 flex items-center justify-center">
                  <div className="w-1/2">
                    <Progress percent={uploadProgress} status="active" />
                  </div>
                </div>
                <div className="w-full h-1/2 flex items-center justify-center">
                  <ActionButton
                    className={"py-3 px-4 h-10"}
                    buttonStyle="w-full"
                    textStyle=""
                    style="px-4 py-4"
                    title="Cancel Uploads"
                    width="full"
                    onClick={() => handleCancelUpload()}
                  />
                </div>
              </div>
            </Card>
          </section>
        </div>
      </div>
    );
};

export default PostEditor;
